exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".popComments {\n  width: 1000px;\n  max-width: 1000px !important;\n}\n\n.tableForceWrap {\n  word-break: break-word !important;\n}", ""]);

